import React, {useEffect, useState} from "react";
import {getStorage, ref, getDownloadURL} from "firebase/storage";
import {
  getFirestore, doc, updateDoc, serverTimestamp
} from "firebase/firestore";
import {Button} from "@mui/material";
import {getFunctions, httpsCallable} from "firebase/functions";
import {useSnackbar} from "notistack";
import {useAdmin} from "./AdminContext.js";
import {useUser} from "../UserContext.js";
import {Box} from "@mui/material";
import "./../Styles.css";
import {listAll} from "firebase/storage";


export default function AdminManageFiles() {
  const {requests} = useAdmin();
  const {appUser} = useUser();
  const {enqueueSnackbar} = useSnackbar();
  const [files, setFiles] = useState([]);
  const [fileLink, setFileLink] = useState("");
  const [loading, setLoading] = useState(false);
  const functions = getFunctions();

  async function downloadFile() {
    setLoading(true);
    try {
      var createFile = httpsCallable(functions, 'createRequestsFile');
      const result = await createFile();
      if (result.data.success) {
        const storage = getStorage();
        const fileName = result.data.fileLink;
        const parts = fileName.split('/');
        const downloadName = parts[parts.length - 1];
        const fileRef = ref(storage, fileName);
        const url = await getDownloadURL(fileRef);
        setFileLink(url);

        // Create a new anchor element dynamically
        const anchor = document.createElement("a");
        anchor.href = url; // Set href to the download URL
        anchor.download = downloadName; // The download attribute specifies the name of the file
        document.body.appendChild(anchor); // Append anchor to the body
        anchor.click(); // Programmatically trigger a click event
        document.body.removeChild(anchor); // Remove the anchor from the body
      } else {
        enqueueSnackbar(result.data.reason, {variant: "error"});
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      enqueueSnackbar("Failed to download file", {variant: "error"});
    }
    setLoading(false);
  }

  useEffect(() => {
    async function reviewStorageFiles() {
      const storage = getStorage();
      const listRef = ref(storage, 'requested');
      const list = await listAll(listRef);
      let tempItems = [];
      let orderedItems = [];
      list.items.forEach(async (item, i) => {
        const url = await getDownloadURL(item);
        const millis = item.name.split('_')[1].split('.')[0];
        tempItems = [...tempItems, {url: url, date: new Date(parseInt(millis))}];
        orderedItems = tempItems.sort((a, b) => {
          return b.date - a.date;
        }
        );
        setFiles(orderedItems);
      });
      setFiles(orderedItems);
    }
    reviewStorageFiles();
  }, [fileLink]);

  function rejectRequest(id) {
    const db = getFirestore();
    const docRef = doc(db, "requests", id);
    updateDoc(docRef, {rejected: serverTimestamp(), rejectedBy: appUser.id});
  }

  return (
    <>
      <Box sx={{
        bgcolor: "background.paper", alignItems: "center", margin: "auto", width: "100%"
      }}>
        <div className="column" align="center">
          <div className="table-container">
            <table>
              <thead>
                <tr key={"headers"}>
                  <th key={"account"}>Account</th>
                  <th key={"symbol"}>Symbol</th>
                  <th key={"amount"}>Amount</th>
                  <th key={"status"}>Status</th>
                  <th key={"reject"}>Action</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((item, index) => (
                  (item.submitted && !item.rejected ?
                    <tr key={"request-submitted" + index}>
                      <td key={"account-td" + index}>{item.account}</td>
                      <td key={"symbol-td" + index}>{item.symbol}</td>
                      <td key={"quantity-td" + index}>{item.granted ? item.granted : item.amount}</td>
                      <td key={"status-td" + index}>
                        {item.submitted.seconds ? item.submitted.toDate().toLocaleString() : new Date(item.submitted).toLocaleString()}
                      </td>
                      <td key={"reject" + index}><button onClick={() => {rejectRequest(item.id)}}>Reject</button></td>
                    </tr>
                    :
                    (
                      item.rejected ?
                        <tr key={"request-rejected" + index}>
                          <td key={"account" + index}>{item.account}</td>
                          <td key={"symbol" + index}>{item.symbol}</td>
                          <td key={"quantity" + index}>{item.amount}</td>
                          <td key={"status" + index}>{"Rejected"}</td>
                        </tr>
                        :
                        <tr key={"request-new" + index}>
                          <td key={"account" + index}>{item.account}</td>
                          <td key={"symbol" + index}>{item.symbol}</td>
                          <td key={"quantity" + index}>{item.granted ? item.granted : item.amount}</td>
                          <td key={"status" + index}>{"New"}</td>
                          <td key={"reject" + index}><button onClick={() => {rejectRequest(item.id)}}>Reject</button> </td>
                        </tr>
                    )
                  )
                ))}
              </tbody>
            </table>
          </div>
          <div align="column">
            <Button className="login-button left-locates" onClick={downloadFile} disabled={loading}>{loading ? "Creating ..." : "Create file to download"}</Button>
            {files.length > 0 &&
              <div className="table-container">
                <table>
                  <thead>
                    <tr key={"headers-files"}>
                      <th key={"name"}>File Name</th>
                      <th key={"locates"}>Date Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {files && files.map((item, index) => (
                      <tr key={"file" + index}>
                        <td key={"url" + index}>
                          <a href={item.url} download>Download</a>
                        </td>
                        <td key={"date" + index}>{new Date(item.date).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
      </Box>
    </>
  );
}
